var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "item" }, [
    _c("div", { staticClass: "form-group form checkox-input item-name" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.itemsSelected,
            expression: "itemsSelected"
          }
        ],
        attrs: {
          id: "result-" + _vm.itemID,
          type: "checkbox",
          autocomplete: "off"
        },
        domProps: {
          value: _vm.result,
          checked: Array.isArray(_vm.itemsSelected)
            ? _vm._i(_vm.itemsSelected, _vm.result) > -1
            : _vm.itemsSelected
        },
        on: {
          change: [
            function($event) {
              var $$a = _vm.itemsSelected,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = _vm.result,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.itemsSelected = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.itemsSelected = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.itemsSelected = $$c
              }
            },
            function($event) {
              return _vm.selectHandler()
            }
          ]
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "result-" + _vm.itemID } }, [
        _vm._v(_vm._s(_vm.result.SupplierName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item-wrapper" }, [
      _c("div", { staticClass: "item-heading" }, [
        _c("div", { staticClass: "item-name" }, [
          _c(
            "button",
            {
              staticClass: "product-item-title-as-button",
              on: {
                click: function($event) {
                  return _vm.getSingleSupplierDetail(_vm.result.SupplierId)
                }
              }
            },
            [
              _c("h4", {
                domProps: { innerHTML: _vm._s(_vm.result.SupplierName) }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "favorite-wrapper" }, [
          _c("div", { staticClass: "favorite-container" }, [
            _c("button", {
              staticClass: "favorite-button js-favorite-button hide-mobile",
              class: _vm.isFavorite ? "favorited" : "not-favorited",
              attrs: { tabindex: "0" },
              on: {
                click: function($event) {
                  return _vm.setMySupplier(_vm.result.SupplierId)
                }
              }
            }),
            _vm._v(" "),
            !_vm.isFavorite
              ? _c("div", { staticClass: "favorite-tooltip" }, [
                  _vm._v("\n            Select as My Supplier\n          ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isFavorite
              ? _c("div", { staticClass: "favorite-tooltip" }, [
                  _vm._v("My Supplier")
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("span", {
          staticClass: "favorite-button hide-desktop",
          class: _vm.isFavorite ? "favorited" : "not-favorited"
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-rating-container" }, [
        _vm.result.NAPStarRating == 1
          ? _c("div", { staticClass: "item-rating" }, [
              _c("span", { staticClass: "icon icon-star" }),
              _vm._v(" "),
              _c("span", { staticClass: "icon icon-star-empty" }),
              _vm._v(" "),
              _c("span", { staticClass: "icon icon-star-empty" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.result.NAPStarRating == 2
          ? _c("div", { staticClass: "item-rating" }, [
              _c("span", { staticClass: "icon icon-star" }),
              _vm._v(" "),
              _c("span", { staticClass: "icon icon-star" }),
              _vm._v(" "),
              _c("span", { staticClass: "icon icon-star-empty" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.result.NAPStarRating == 3
          ? _c("div", { staticClass: "item-rating" }, [
              _c("span", { staticClass: "icon icon-star" }),
              _vm._v(" "),
              _c("span", { staticClass: "icon icon-star" }),
              _vm._v(" "),
              _c("span", { staticClass: "icon icon-star" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.result.NAPStarRating == "DP"
          ? _c("div", { staticClass: "item-rating" }, [
              _vm._v("\n        DP\n      ")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item-details-container", attrs: { tabindex: "0" } },
        [
          _c("div", {
            staticClass: "item-details",
            domProps: { innerHTML: _vm._s(_vm.result.ProgramProducts) }
          }),
          _vm._v(" "),
          _vm.result.LongProgramProducts != null
            ? _c("div", {
                staticClass: "item-details-tooltip",
                domProps: { innerHTML: _vm._s(_vm.result.LongProgramProducts) }
              })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "unstyled-button",
          on: {
            click: function($event) {
              return _vm.getSingleSupplierDetail(_vm.result.SupplierId)
            }
          }
        },
        [_vm._v("\n      View\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01905986", { render: render, staticRenderFns: staticRenderFns })
  }
}